import { invariant } from './utils/invariant';

interface PublicEnv {
    keycloakUrl: string;
    keycloakRealm: string;
    keycloakClientId: string;
    apiBaseUrl: string;
    envLabel: string;
}

function requireEnv(name: string): string {
    const value = import.meta.env[name];
    invariant(typeof value === 'string' && value.length > 0, `Missing required env var ${name}`);
    return value;
}

export const env: PublicEnv = {
    keycloakUrl: requireEnv('VITE_KEYCLOAK_URL'),
    keycloakRealm: requireEnv('VITE_KEYCLOAK_REALM'),
    keycloakClientId: requireEnv('VITE_KEYCLOAK_CLIENT_ID'),
    apiBaseUrl: requireEnv('VITE_API_BASE_URL'),
    envLabel: import.meta.env.VITE_APP_ENV_LABEL ?? 'dev',
};
